"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pago-del-vallo-di-lauro": {
    "fbc617b7": [{
      "hkey": "a283bbf4",
      "slug": "pago-del-vallo-di-lauro",
      "name": "Pago del Vallo di Lauro",
      "primary": true,
      "skipSearch": false
    }],
    "pernosano": [{
      "hkey": "a283bbf4",
      "slug": "pago-del-vallo-di-lauro",
      "name": "Pago del Vallo di Lauro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;